import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-text-field-modal-popover',
  templateUrl: './text-field-confirm-modal.component.html',
  styleUrls: ['./text-field-confirm-modal.component.scss'],
})
export class TextFieldConfirmModalComponent {

  @Input() textFieldLabel: string = '';
  textFieldValue: string = '';

  constructor(private modalController: ModalController) {}

  cancel() {
    this.modalController.dismiss(null, 'CANCEL');
  }

  confirmFieldValue() {
    if (this.textFieldValue.trim()) {
      // Przekazujemy wpisaną wartość w zmiennej 'data' i rolę 'CONFIRM'
      this.modalController.dismiss(this.textFieldValue, 'CONFIRM');
    }
  }
}
